import React, {Component} from 'react';
import { connect } from 'dva';
import BaseComponent, {LoadingSpinner} from '../../../components/BaseComponent';
import Dimio from '../../../components/Dimio';

//import TravelTemplate01 from './travel/TravelTemplate01';

//const loadTravelTemplate = './travel/TravelTemplate01';

class LoadAd extends BaseComponent {
  constructor(props) {
    super(props);

    this.state = {
      adData: false
    }
  }

  componentWillMount() {
    const {dispatch, ad, category} = this.props;
    console.info(this.props);
    const self = this;
    const url = (category.url)?category.url:null;

    if(ad && url) {
      this.load(category.url, {
        query: {key: ad, ri: 3},
        onSuccess(res){
          console.info(ad, res.data);
          self.setState({adData: res.data, category: category.category});
        },
        onError(err){
          console.info(err);
        }
      });
    }
  }

  render(){
    const {adData, category} = this.state;
    console.info(category, adData);

    //const map = {travel: './school/SchoolTemplate01', school: './school/SchoolTemplate01'};
    let Template = null;

    if(adData){
      if(category === 'travel') {
        Template = require('./travel/TravelTemplate01').default;
        return (<Template data={adData}/>);
      }
      if(category === 'school') {
        Template = require('./school/SchoolTemplate01').default;
        return (<Template data={adData}/>);
      }

      return null;
    }

    return null;
/*
    return(
      <div>
        {Template &&
          <Template data={adData}/>
        }
      </div>
    )
    */
  }
}

export default connect(({ meta }) => ({
  meta
}))(LoadAd);


// WEBPACK FOOTER //
// ./src/pages/school_blog/components/LoadAd.js